enum AdderWidgetEvents {
  AddToTruckClick = 'product_add_to_cart_tap',
  ChangeProductQty = 'product_change_qty',
  ChageProductQtyInTruck = 'product_change_cart',
  GoToCheckout = 'product_go_to_cart',
  HowItWorksClick = 'product_how_it_works',
}

export default AdderWidgetEvents
